

export function stringToBoolean(str: string | undefined | null) {

  if(str === null || str === undefined) {
    return false;
  }

  if (typeof str !== 'string')
    return Boolean(str); // fallback for non-strings

  const trimmed = str.trim().toLowerCase();
  return !(trimmed === '0' || trimmed === 'false' || trimmed === '');
}